import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Lock } from 'lucide-react'
import { getPlans } from '../api/auth'
import Button from '../components/Button'
import EmptyState from '../components/EmptyState'
import { MODULE_NAMES, useSession } from '../session'

/** The add-on on the company's plan, or the smallest plan in its line (else
    any line) that brings `module` ('a|b' means either). */
function whereToGet(catalogue, planId, module) {
  const wanted = String(module || '').split('|')
  const plans = catalogue?.plans || []
  const current = plans.find((p) => p.id === planId)
  if (current?.addons.some((a) => wanted.includes(a.key))) return { addon: true }
  const has = (p) => wanted.some((m) => p.modules.includes(m))
  const target = plans.find((p) => current && p.line === current.line && has(p))
    || [...plans].filter(has).sort((a, b) => a.price - b.price)[0]
  return target ? { plan: target.label } : null
}

/** Shown in place of a page whose module isn't in the company's plan. */
export default function NotInPlan({ module }) {
  const name = String(module || '').split('|').map((m) => MODULE_NAMES[m]).filter(Boolean).join(' or ') || 'This part'
  const { roles = [], user } = useSession()
  const admin = roles.includes('admin')
  const nav = useNavigate()
  const [catalogue, setCatalogue] = useState(null)
  useEffect(() => { getPlans().then(setCatalogue).catch(() => {}) }, [])
  const where = whereToGet(catalogue, user?.plan, module)
  const how = where?.addon ? `add ${name} to your plan as an add-on` : where?.plan ? `move to ${where.plan}, which includes ${name}` : `add ${name} to your plan`
  return (
    <div className="page">
      <EmptyState
        icon={<Lock size={28} />}
        message={`${name} isn’t in your plan`}
        description={admin
          ? `Under Plan & billing you can ${how}. It switches on at once, with no set-up.`
          : `Ask an admin in your company to ${how}.`}
        action={admin
          ? <Button size="sm" onClick={() => nav('/settings/plan')}>See plans</Button>
          : <Button size="sm" variant="ghost" onClick={() => nav('/dashboard')}>Back to the overview</Button>}
      />
    </div>
  )
}
